<div class="">
  <app-card-document [bodyList]="detailDocumentDistributor" [loading]="isLoading" [title]="'Dokumen'"></app-card-document>
  <div class="my-7">
    <app-card-document [bodyList]="detailDocumentNpwp" [loading]="isLoading" [title]="'Dokumen NPWP'"></app-card-document>
  </div>
  <app-card-document [bodyList]="detailDocumentActivation" [loading]="isLoading" [title]="'Dokumen Aktivasi'"></app-card-document>
</div>
